/**
 * CardItem.jsx - CORRIGÉ
 *
 * Affiche une carte individuelle avec :
 * - Image (ratio 2:3)
 * - Nom
 * - Ancien prix barré + nouveau prix en rouge
 * - Bouton favoris à DROITE du prix
 * - Design Ant Design
 */

import React from "react";
import { Link } from "react-router-dom";
import { Card, Button, Space } from "antd";
import { HeartOutlined, HeartFilled } from "@ant-design/icons";
import { useAuth } from "../../context/AuthContext";
import { addFavorite, removeFavorite } from "../../api/api";
import { formatPrice } from "../../utils/formatters";
import { useTheme } from "../../context/ThemeContext";

/**
 * Bouton favoris
 */
function FavoriteButton({ card }) {
    const { token } = useAuth();
    const [isFavorite, setIsFavorite] = React.useState(
        card.favorite_status === "FAVORITE"
    );

    const handleFavorite = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!token) {
            alert("Connectez-vous pour ajouter aux favoris !");
            return;
        }

        try {
            if (isFavorite) {
                await removeFavorite(card.id);
            } else {
                await addFavorite(card.id);
            }
            setIsFavorite(!isFavorite);
        } catch (err) {
            console.error(err);
            alert("Erreur favoris");
        }
    };

    return (
        <Button
            type="text"
            icon={isFavorite ? <HeartFilled /> : <HeartOutlined />}
            onClick={handleFavorite}
            danger={isFavorite}
            size="large"
        />
    );
}

/**
 * CardItem - Composant carte
 */
export default function CardItem({ card }) {
    const { isDarkMode } = useTheme();

    // ✅ Récupérer l'ancien prix et le nouveau prix
    const rawOffers = card.all_offers || [];

// 1️⃣ Trier par date DESC (plus récente en premier)
    const offers = [...rawOffers].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
    );

    let oldPrice = null;
    let newPrice = null;
    let devise = "$";
    let isSold = false;

    if (offers.length > 0) {
        const latest = offers[0];
        const latestStatus = (latest.status || "").trim().toUpperCase();

        devise = latest.devise || devise;

        if (latestStatus === "SOLD") {
            // ✅ Cas carte vendue → uniquement prix barré
            newPrice = parseFloat(latest.price);
            isSold = true;
        } else if (latestStatus === "IN_SELL") {
            newPrice = parseFloat(latest.price);

            // Chercher la précédente IN_SELL (pas forcément index 1)
            const previous = offers.find(
                (o, index) =>
                    index > 0 &&
                    (o.status || "").trim().toUpperCase() === "IN_SELL"
            );

            if (
                previous &&
                parseFloat(previous.price) !== newPrice
            ) {
                oldPrice = parseFloat(previous.price);
            }
        }
    }

    return (
        <Link to={`/cards/${card.id}`} style={{ textDecoration: "none" }}>
            <Card
                hoverable
                style={{
                    height: "100%",
                    background: isDarkMode ? "#1f1f1f" : "#ffffff",
                }}
                bodyStyle={{ padding: "12px" }}
                cover={
                    <div
                        style={{
                            width: "100%",
                            aspectRatio: "2/3",
                            overflow: "hidden",
                            background: isDarkMode ? "#141414" : "#f0f0f0",
                        }}
                    >
                        <img
                            src={card.image_path}
                            alt={card.name}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                            }}
                            loading="lazy"
                        />
                    </div>
                }
            >
                <div>
                    {/* Nom */}
                    <h3 style={{ margin: "8px 0", fontSize: "14px", fontWeight: "600" }}>
                        {card.name}
                    </h3>

                    <div style={{ flex: 1 }}>
                        {/* CAS CARTE VENDUE */}
                        {isSold ? (
                            <p
                                style={{
                                    margin: 0,
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    textDecoration: "line-through",
                                    opacity: 0.6,
                                }}
                            >
                                {formatPrice(newPrice, devise)}
                            </p>
                        ) : (
                            <>
                                {/* Ancien prix si changement */}
                                {oldPrice && (
                                    <p
                                        style={{
                                            margin: "0 0 4px",
                                            fontSize: "12px",
                                            opacity: 0.5,
                                            textDecoration: "line-through",
                                            color: "#ff4d4f",
                                        }}
                                    >
                                        {formatPrice(oldPrice, devise)}
                                    </p>
                                )}

                                {/* Nouveau prix */}
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        color: oldPrice ? "#ff4d4f" : "inherit",
                                    }}
                                >
                                    {formatPrice(newPrice, devise)}
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </Card>
        </Link>
    );
}